export default __webpack_public_path__ + "d9572ea957200a1632ce95e6c28479cb.png";